import _es from "capability/es5";
import _lib from "./lib";
_es;
export { _lib as default };
export const Class = _lib.Class;